export enum ActionPrefixs {
  page = "page",
  answer = "answer",
  menu = "menu",
  storyA = "storyA",
  storyB = "storyB",
  storyC = "storyC",
  adventureStory = "adventureStory",
  infoDialogA = "infoDialogA",
  infoDialogB = "infoDialogB",
  originalPaintingDialog = "originalPaintingDialog",
  fearCity = "fearCity",
  leadingStoryDialog = "leadingStoryDialog",
  virus = "virus",
  storyDDialog = "storyDDialog",
  storyE = "storyE",
  submitFear = "submitFear",
  infoDialogC = "infoDialogC",
  ending = "ending",
  rabbitCity = "rabbitCity"
}



// WEBPACK FOOTER //
// ./src/common/constants/ActionPrefixs.ts